import { ReCaptchaSetting } from 'backend';
import { PostAuthInputDataPayload, postAuthInputDate } from 'fetcher';
import {
  getReCaptchaRequestPayload,
  handleCommonSubmitError,
  SubmissionAuthResult,
  SUBMISSION_RESULT_TYPE,
} from 'hooks/shared';
import { AuthInputData } from 'shared';
import { useReCaptcha } from '../useReCaptcha';

type SubmitPayload = {
  endpoint: PostAuthInputDataPayload['endpoint'];
  inputData: AuthInputData;
};

type UseSubmitAuthInputDataReturnType = {
  submit: (payload: SubmitPayload) => Promise<SubmissionAuthResult>;
};

type Payload = {
  reCaptchaSetting: ReCaptchaSetting | undefined;
};

export const useSubmitAuthInputData = ({
  reCaptchaSetting,
}: Payload): UseSubmitAuthInputDataReturnType => {
  const { executeReCaptcha } = useReCaptcha(reCaptchaSetting);

  const submit = async ({ endpoint, inputData }: SubmitPayload) => {
    const reCaptchaResult = await executeReCaptcha();
    const reCaptcha = getReCaptchaRequestPayload(reCaptchaResult);
    const payload: PostAuthInputDataPayload['payload'] = {
      inputData,
      currentUrl: location.href,
      reCaptcha,
    };

    try {
      const {
        page,
        inputData: inputDataFromBackend,
        reCaptcha,
        error,
        trackingSetting,
        authentication,
        externalMeasurementTag,
        apiEndpoint,
        fileUpload,
      } = await postAuthInputDate({ endpoint, payload });
      return {
        type: SUBMISSION_RESULT_TYPE.success,
        formPage: page,
        inputData: inputDataFromBackend,
        reCaptchaSetting: reCaptcha,
        error,
        authentication,
        trackingSetting,
        externalMeasurementTag,
        apiEndpoint,
        fileUploadSetting: fileUpload,
      };
    } catch (e: unknown) {
      return handleCommonSubmitError(e);
    }
  };
  return { submit };
};
